import React from "react";
import { FiInstagram ,  FiFacebook } from "react-icons/fi";
import { FaTiktok } from "react-icons/fa";

const Social = () => {
    return (
        <div className="home__social">
            <a href="https://web.facebook.com/ibrahim.hegazy.yousef?mibextid=LQQJ4d&_rdc=1&_rdr" className="home__social-icon" target="_blank">
            <FiFacebook />
            </a>
            <a href="https://www.instagram.com/ibrahim_hegazi2023/?igshid=OGQ5ZDc2ODk2ZA%3D%3D&utm_source=qr" className="home__social-icon" target="_blank">
            <FiInstagram />
            </a>
            <a href="https://www.tiktok.com/@ibrahimhegazi4?_t=8h6kW2sU9FF&_r=1" className="home__social-icon" target="_blank">
            <FaTiktok />
            </a>
        </div> 
    ); 
}

export default Social;